import React from 'react';
import ReactDOM from 'react-dom/client';

// Self-hosted via @fontsource — Discord's activity iframe CSP blocks external
// font CDNs, so the faces have to be bundled rather than linked. latin-ext is
// pulled in for the display and body faces because French article titles and
// prose are full of accented characters.
import '@fontsource/pixelify-sans/latin-400.css';
import '@fontsource/pixelify-sans/latin-700.css';
import '@fontsource/pixelify-sans/latin-ext-700.css';
import '@fontsource/silkscreen/latin-400.css';
import '@fontsource/silkscreen/latin-700.css';
import '@fontsource/jetbrains-mono/latin-400.css';
import '@fontsource/jetbrains-mono/latin-700.css';
import '@fontsource/jetbrains-mono/latin-ext-400.css';
import '@fontsource/jetbrains-mono/latin-ext-700.css';

import App from './App';
import { SettingsProvider } from './ui';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SettingsProvider>
      <App />
    </SettingsProvider>
  </React.StrictMode>
);
